<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-section">
          <div class="footer-logo-title">
            <img src="/yinpu-logo.png" alt="茵普科技 Logo" class="logo-image">
            <h3 class="footer-title">成都茵普科技</h3>
          </div>
          <p class="footer-desc">专注于为企业提供优质的测量解决方案</p>
        </div>
        
        <div class="footer-section">
          <h4 class="footer-subtitle">快速链接</h4>
          <ul class="footer-links">
            <li><router-link to="/">首页</router-link></li>
            <li><router-link to="/products">产品展示</router-link></li>
            <li><router-link to="/about">关于我们</router-link></li>
            <li><router-link to="/contact">联系我们</router-link></li>
          </ul>
        </div>
        
        <div class="footer-section">
          <h4 class="footer-subtitle">联系方式</h4>
          <ul class="footer-contact">
            <li>
              <el-icon><Phone /></el-icon>
              <span>137-0802-2354</span>
            </li>
            <li>
              <el-icon><Location /></el-icon>
              <span>成都市新都区</span>
            </li>
          </ul>
        </div>
        
        <div class="footer-section">
          <h4 class="footer-subtitle">关注我们</h4>
          <div class="social-links">
            <a href="#" class="social-link">
              <el-icon><ChatDotRound /></el-icon>
            </a>
            <a href="#" class="social-link">
              <el-icon><Share /></el-icon>
            </a>
            <a href="#" class="social-link">
              <el-icon><Link /></el-icon>
            </a>
          </div>
        </div>
      </div>
      
      <div class="footer-bottom">
        <p>&copy; {{ currentYear }} 成都茵普科技有限公司. All rights reserved.</p>
        <p class="icp-record">
          <a href="https://beian.miit.gov.cn/" target="_blank">蜀ICP备2024077026号-2</a>
        </p>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { Phone, Location, ChatDotRound, Share, Link } from '@element-plus/icons-vue'

const currentYear = new Date().getFullYear()
</script>

<style scoped lang="scss">
.footer {
  background: linear-gradient(135deg, #699991 0%, #1385e2 100%);
  color: #fff;
  padding: 60px 0 20px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-content {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 40px;
  margin-bottom: 40px;
  
  @media (max-width: 992px) {
    grid-template-columns: 1fr 1fr;
  }
  
  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
}

.footer-logo-title {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.logo-image {
  height: 1em; /* 与文字高度匹配 */
  width: auto;
  max-height: 28px; /* 限制最大高度，不超过文字高度 */
  filter: brightness(0) invert(1); /* 将logo变为白色 */
  transition: opacity 0.3s;
}

.logo-image:hover {
  opacity: 0.9;
}

.footer-title {
  font-size: 24px;
  font-weight: bold;
  margin: 0; /* 移除默认边距 */
}

.footer-desc {
  color: #bdc3c7;
  line-height: 1.6;
}

.footer-subtitle {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
}

.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
  
  li {
    margin-bottom: 10px;
    
    a {
      color: #bdc3c7;
      text-decoration: none;
      transition: color 0.3s;
      
      &:hover {
        color: #fff;
      }
    }
  }
}

.footer-contact {
  list-style: none;
  padding: 0;
  margin: 0;
  
  li {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 12px;
    color: #bdc3c7;
    
    .el-icon {
      font-size: 18px;
    }
  }
}

.social-links {
  display: flex;
  gap: 12px;
}

.social-link {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  text-decoration: none;
  transition: all 0.3s;
  
  &:hover {
    background: #409eff;
    transform: translateY(-3px);
  }
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 20px;
  text-align: center;
  color: #bdc3c7;
}

.icp-record {
  margin-top: 8px;

  a {
    color: #bdc3c7;
    text-decoration: none;
    transition: color 0.3s;

    &:hover {
      color: #fff;
    }
  }
}
</style>
